import * as actions from './extCalendly.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ExtCalendlyConfigModel } from '@smarttask-common/src/lib/models/Integrations/Calendly/ExtCalendlyConfigModel';

export const configAdapter = createEntityAdapter<ExtCalendlyConfigModel>({
    selectId: (x) => x.config_id,
});
export interface ExtCalendlyConfigState extends EntityState<ExtCalendlyConfigModel> {
    selected_config_id: string;
}

export const initialState: ExtCalendlyConfigState = configAdapter.getInitialState({
    selected_config_id: undefined,
});

export function ExtCalendlyConfigReducers(state: ExtCalendlyConfigState = initialState, action: actions.ExtCalendlyConfigActions) {
    switch (action.type) {
        case actions.ExtCalendlyConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_config_id: action.selected_config_id };
            return state;

        case actions.ExtCalendlyConfigActionTypes.ADD_EXT_CALENDLY_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.ExtCalendlyConfigActionTypes.ADD_EXT_CALENDLY_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.ExtCalendlyConfigActionTypes.UPSERT_EXT_CALENDLY_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.ExtCalendlyConfigActionTypes.UPSERT_EXT_CALENDLY_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.ExtCalendlyConfigActionTypes.UPDATE_EXT_CALENDLY_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.ExtCalendlyConfigActionTypes.UPDATE_EXT_CALENDLY_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.ExtCalendlyConfigActionTypes.DELETE_EXT_CALENDLY_CONFIG:
            return configAdapter.removeOne(action.config_id, state);

        case actions.ExtCalendlyConfigActionTypes.DELETE_EXT_CALENDLY_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.ExtCalendlyConfigActionTypes.DELETE_ALL_EXT_CALENDLY_CONFIGS:
            return configAdapter.removeMany(action.config_ids, state);

        case actions.ExtCalendlyConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getExtCalendlyConfigState = createFeatureSelector<ExtCalendlyConfigState>('extCalendlyConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getExtCalendlyConfigState);

const getSelectedConfigIdState = (state: ExtCalendlyConfigState) => {
    return state.selected_config_id;
};
export const getSelectedConfigId = createSelector(getExtCalendlyConfigState, getSelectedConfigIdState);

export const getSelectedConfig = createSelector(getExtCalendlyConfigState, (state: ExtCalendlyConfigState) => {
    if (state.selected_config_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_config_id];
});
